<template>
  <div 
    class="alertBar d-flex align-items-center justify-content-center" 
    :style="[{backgroundColor: backgroundColor}]">
    <h4 
      class="alertBar-message" 
      :style="{color: textColor}">
      {{ message }} <nav-link class="text-nowrap px-4" v-for="link in linkText" :key="link" href="/announcements/crisis-info" :style="[{color: textColor}]">{{ link }}</nav-link>
    </h4>
  </div>
</template>

<script>
export default {
  name: 'alertBar',
  analyticsCategory: 'Alert Bar',
  props: {
    message: String,
    linkText: Array,
    textColor: String,
    backgroundColor: String,
  }
};
</script>

<style scoped lang="scss">
.alertBar {
  position: fixed;
  left: 0;
  width: 100%;
  height: 60px;
  max-height: 60px;
  padding: 12px;
  z-index: 5000;
  animation: slide-down .3s ease-in;

  &-message {
    text-align: center;
    font-weight: 600;
    margin-bottom: 0;
    font-size: 16px;

    @media(min-width: 768px) {
      font-size: 20px;
    }

    @media(min-width: 992px) {
      font-size: 24px;
    }

  }

  @keyframes slide-down {
    0% {
      transform: translateY(-65px);
    }

    100% {
      transform: translateY(0);
    }
  }
}
</style>
